import { render, staticRenderFns } from "./mode2.vue?vue&type=template&id=f348ce04&scoped=true"
import script from "./mode2.vue?vue&type=script&lang=js"
export * from "./mode2.vue?vue&type=script&lang=js"
import style0 from "./mode2.vue?vue&type=style&index=0&id=f348ce04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f348ce04",
  null
  
)

export default component.exports